import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FieldComponent } from './field/field.component';

@NgModule({
    imports: [RouterModule.forRoot([
        { path: '', component: FieldComponent  }
    ])],
    exports: [RouterModule]
})
export class CtRoutingModule {}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/ct-routing.module.ts